import { useMemo } from 'react';
import styled from 'styled-components';
import { Asset, AssetSubfolder } from '../../../types';
import { useSelectionContext } from '../../../contexts/SelectionContext';
import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { pxToRem } from 'utils/convert';
import { GroupSelect as UnstyledGroupSelect } from 'ui/indexPages/tables/groupSelect';
import { isSelectionContent, isSelectionFolder } from 'utils/contexts/selection';

const StyledGroupSelect = styled(UnstyledGroupSelect)`
  margin-left: -${pxToRem(9)};
`;

// assets will eventually be read in through a hook in future PR
export const GroupSelect = ({
  assets,
  folders,
}: { assets: Asset[]; folders: AssetSubfolder[] }) => {
  const { addPageToBulk, removePageFromBulk, bulk } = useSelectionContext();
  const totalSelectableItems = folders.length + assets.length;

  const totalSelectedItemsOnPage = useMemo(() => {
    const selectedFolderIds = bulk.filter(isSelectionFolder).map(({ id }) => id);
    const selectedTemplateIds = bulk.filter(isSelectionContent).map(({ id }) => id);
    const foldersSelectedOnPage = folders.filter(({ id }) => selectedFolderIds.includes(id));
    const assetsSelectedOnPage = assets.filter(({ id }) => selectedTemplateIds.includes(id));
    return foldersSelectedOnPage.length + assetsSelectedOnPage.length;
  }, [bulk, folders, assets]);

  let groupSelectStatus = CHECKBOX_STATUS.INDETERMINATE;
  if (bulk.length === 0) {
    groupSelectStatus = CHECKBOX_STATUS.UNCHECKED;
  } else if (totalSelectedItemsOnPage === totalSelectableItems) {
    groupSelectStatus = CHECKBOX_STATUS.CHECKED;
  }

  return (
    <StyledGroupSelect
      onSelectAll={addPageToBulk}
      onSelectNone={removePageFromBulk}
      status={groupSelectStatus}
    />
  );
};
